<h1>Export eines durchlaufenden Videos</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Neben dem Publizieren von HTML5-Anwendungen, bietet Ihnen video2manual
        die Möglichkeit, durchlaufende Videos zu exportieren.
      </p>
      <p>
        Dabei sind Verknüpfungen und Interaktionen nicht anwendbar. Die im
        Projekt enthaltenen Clips werden sukzessive abgespielt. Diese Dateien im
        mp4-Format können auf Video-Plattformen im Internet geladen werden oder
        zur vorläufigen Veranschaulichung z. B. beim Kunden dienen.
      </p>
      <p>
        Sie können exportierte Videos auch archivieren und Metadaten ergänzen.
      </p>
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
